import httpClienteSeguridad from '../../Servicios/HttpClienteSeguroSeguridad';

/**
 * obtener texto seguro 
 * @param {{ UserEmail:string, CustomerId: Guid, FullName: string, BaseUrl: string, CompanyId: Guid, UserId: Guid }} objRequest
 * @returns {Promise<{data:string, status:number, statusText:string}>}
 */
export const obtenerDatosAppExternas = (objRequest) => {

    return new Promise((resolve, reject) => {
        httpClienteSeguridad.post('/DatosAppExternas/Datos', objRequest).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });

};

/**
 * obtener texto seguro 
 * @param {{ CodigoApp:string }} objRequest
 * @returns {Promise<{data:string, status:number, statusText:string}>}
 */
export const validarLicenciaAppExterna = (codigoApp) => {

    return new Promise((resolve, reject) => {
        httpClienteSeguridad.post('/DatosAppExternas/ValidarLicencia', { CodigoApp: codigoApp }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });

};